import { apiGatewayCogntioClient } from "../utils/apigatewayHelper";

export const Get_Help = "Get_Help";

import { store } from "../main";

export function checkAdminStatus() {
    const appState = store.getState();
    const token = appState.authenticationObj.userDetails.jwtToken;
    let apiClient = apiGatewayCogntioClient();
    let headers = {
        //If there are query parameters or headers that need to be sent with the request you can add them here
        headers: {
            Authorization: token
        }
    };

    return apiClient.invokeApi({}, '/api/employee/is-group-member?groupName=cript-leadership', "GET", headers);
}

export async function checkIsALTAR() {
    const appState = store.getState();
    const token = appState.authenticationObj.userDetails.jwtToken;
    let apiClient = apiGatewayCogntioClient();
    let headers = {
        //If there are query parameters or headers that need to be sent with the request you can add them here
        headers: {
            Authorization: token
        }
    };

    const isAltarTeam: { data: boolean } = await apiClient.invokeApi({}, '/api/employee/is-group-member?groupName=altar', "GET", headers)
    const isD2DTeam: { data: boolean } = await apiClient.invokeApi({}, '/api/employee/is-group-member?groupName=gtpc-tech-dev-d2d', "GET", headers)

    return { data: isAltarTeam.data || isD2DTeam.data };
}